/**
 * DIE KLADDE (NT-TUTORIAL-KLADDE-01) — API-Wrapper. Typen spiegeln
 * apps/backend/src/modules/kladde/kladde.service.ts (KladdeState) 1:1.
 */

import { api } from './api.js';

export interface KladdeMilestoneView {
  key: string;
  label: string;
  body: string;
  optional: boolean;
  done: boolean;
  recommendation: string | null;
}

export interface KladdeProgressView {
  key: string;
  anchorBeforeMilestone: string;
  label: string;
  body: string;
  currentCents: string;
  targetCents: string;
  percent: number;
  complete: boolean;
}

export interface KladdeStageView {
  id: 1 | 2 | 3;
  title: string;
  lede: string;
  visible: boolean;
  complete: boolean;
  milestones: KladdeMilestoneView[];
  progressBars: KladdeProgressView[];
}

export interface KladdeHintView {
  key: string;
  title: string;
  body: string;
  triggered: boolean;
  dismissed: boolean;
}

export interface KladdeState {
  dismissed: boolean;
  hasOpenPanel: boolean;
  stages: KladdeStageView[];
  hints: KladdeHintView[];
}

export function fetchKladdeState(): Promise<KladdeState> {
  return api.get<KladdeState>('/kladde');
}

export function dismissKladdePanel(): Promise<{ dismissed: boolean }> {
  return api.post<{ dismissed: boolean }>('/kladde/dismiss', {});
}

export function dismissKladdeHint(key: string): Promise<{ dismissed: boolean; key: string }> {
  return api.post<{ dismissed: boolean; key: string }>(`/kladde/hint/${encodeURIComponent(key)}/dismiss`, {});
}
